import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IVisaProcessingOption,
  IVisaProcessingOptionState,
} from "./visaprocessingoptionModel";
import {
  createVisaProcessingOption,
  deleteVisaProcessingOption,
  getAllActiveVisaProcessingOptions,
  getAllVisaProcessingOptions,
  getVisaProcessingOptionByID,
  updateVisaProcessingOption,
  visaProcessingOptionActiveInactive,
} from "./services/visaprocessingoption.services";

const initialState: IVisaProcessingOptionState = {
  loading: false,
  formLoading: false,
  error: "",
  VisaProcessingOptionList: [],
  VisaProcessingOptionID: null,
  VisaProcessingOptionDetail: {
    VisaCountryID: null,
    Type: "",
    Duration: "",
    Description: "",
    Price: null,
    IsActive: 1,
  },
};

const visaProcessingOptionSlice = createSlice({
  name: "visaprocessingoption",
  initialState,
  reducers: {
    clearVisaProcessingOptionDetails: (state) => {
      state.VisaProcessingOptionDetail =
        initialState.VisaProcessingOptionDetail;
    },
    setVisaProcessingOptionID: (state, action) => {
      state.VisaProcessingOptionID = action.payload;
    },
    clearVisaProcessingOptionID: (state) => {
      state.VisaProcessingOptionID = initialState.VisaProcessingOptionID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVisaProcessingOptions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVisaProcessingOptions.fulfilled,
      (state, action: PayloadAction<IVisaProcessingOption[]>) => {
        state.loading = false;
        state.VisaProcessingOptionList = action.payload || [];
      }
    );
    builder.addCase(getAllVisaProcessingOptions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaProcessingOptionList = [];
    });
    builder.addCase(getAllActiveVisaProcessingOptions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVisaProcessingOptions.fulfilled,
      (state, action: PayloadAction<IVisaProcessingOption[]>) => {
        state.loading = false;
        state.VisaProcessingOptionList = action.payload || [];
      }
    );
    builder.addCase(
      getAllActiveVisaProcessingOptions.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.VisaProcessingOptionList = [];
      }
    );
    builder.addCase(createVisaProcessingOption.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVisaProcessingOption.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVisaProcessingOption.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVisaProcessingOption.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVisaProcessingOption.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVisaProcessingOption.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVisaProcessingOption.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVisaProcessingOption.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVisaProcessingOption.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(visaProcessingOptionActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(visaProcessingOptionActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      visaProcessingOptionActiveInactive.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(getVisaProcessingOptionByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getVisaProcessingOptionByID.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.VisaProcessingOptionDetail = action.payload;
      }
    );
    builder.addCase(getVisaProcessingOptionByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VisaProcessingOptionDetail =
        initialState.VisaProcessingOptionDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearVisaProcessingOptionDetails,
  setVisaProcessingOptionID,
  clearVisaProcessingOptionID,
} = visaProcessingOptionSlice.actions;
export default visaProcessingOptionSlice.reducer;
